import { render, staticRenderFns } from "./StudyConversationMessageHeader.vue?vue&type=template&id=6ad206ea&scoped=true"
import script from "./StudyConversationMessageHeader.vue?vue&type=script&lang=js"
export * from "./StudyConversationMessageHeader.vue?vue&type=script&lang=js"
import style0 from "./StudyConversationMessageHeader.vue?vue&type=style&index=0&id=6ad206ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad206ea",
  null
  
)

export default component.exports